import {
  getWidgetShadowRoot,
  removeScopedStyleTag,
  upsertScopedStyleTag,
} from "../../domStyles";
import { getFeatureTarget } from "../../featureTargets";

const FEATURE_ID = "monochrome";
const STYLE_ID = "incluway-monochrome-style";
const CLASS = "incluway-monochrome";

function getWidgetHtmlEl(): HTMLElement | null {
  const shadowRoot = getWidgetShadowRoot();
  return shadowRoot?.querySelector("html") ?? null;
}

export function enableMonochrome() {
  document.documentElement.classList.add(CLASS);
  getWidgetHtmlEl()?.classList.add(CLASS);

  upsertScopedStyleTag({
    id: STYLE_ID,
    target: getFeatureTarget(FEATURE_ID, "both"),
    pageCss: `
html.${CLASS} {
  filter: grayscale(100%) !important;
}
`.trim(),
    widgetCss: `
html.${CLASS} {
  filter: grayscale(100%) !important;
}
`.trim(),
  });
}

export function disableMonochrome() {
  document.documentElement.classList.remove(CLASS);
  getWidgetHtmlEl()?.classList.remove(CLASS);

  removeScopedStyleTag(STYLE_ID);
}
